import { useState } from "react";
import { CloseCircleOutlined } from "@ant-design/icons";
import general from "../../general";
import { useInterval, useToggle } from "ahooks";
import Dialog from "../../lib/Dialog";
import CryptoJS from "crypto-js";
import dayjs from "dayjs";
import { useLogin } from "../../lib/LoginContext";

// 忘记密码
export default () => {
  const [data, setData] = useState({
    mobile: "",
    code: "",
    newpassword: "",
  });

  const [newpassword, { toggle: toggleNewpassword }] = useToggle(true);

  const { setPswEditShow } = useLogin();

  const [coding, setCoding] = useState(false);
  const [codeTime, setCodeTime] = useState(0);
  useInterval(() => {
    if (codeTime) {
      setCodeTime(codeTime - 1);
    }
  }, 1000);

  const encodeAndHash = (value) => {
    // Base64 编码
    const base64Encoded = CryptoJS.enc.Base64.stringify(
      CryptoJS.enc.Utf8.parse(value)
    );

    // MD5 加密
    const md5Hash = CryptoJS.MD5(base64Encoded).toString(CryptoJS.enc.Hex);

    return md5Hash;
  };

  const code = () => {
    if (!data.mobile) {
      Dialog.error("请输入手机号");
      return;
    }
    if (coding || codeTime) {
      return;
    }
    setCoding(true);
    Dialog.loading();

    let str = `03${data.mobile}${dayjs().unix().toString()}`;

    // 忘记密码
    general.axios
      .post("/v3/base/tool/getVerifyCode", {
        mobile: data.mobile,
        code: "code",
        type: "03",
        time: dayjs().unix().toString(),
        sign: encodeAndHash(str),
      })
      .finally(() => {
        setCoding(false);
        Dialog.close();
      })
      .then((response) => {
        let result = response.data;
        if (!result.status.succeed) {
          Dialog.error(result.status.error_desc);
        } else {
          setCodeTime(60);
        }
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  const [submitting, setSubmitting] = useState(false);
  const submit = () => {
    if (submitting) {
      return;
    }
    if (!data.mobile) {
      Dialog.error("请输入手机号");
      return;
    }
    if (!data.code) {
      Dialog.error("请输入验证码");
      return;
    }
    if (!data.newpassword) {
      Dialog.error("请输入新密码");
      return;
    }
    setSubmitting(true);
    Dialog.loading();
    general.axios
      .post("/v3/user/user/forgetPwd", data)
      .finally(() => {
        setSubmitting(false);
        Dialog.close();
      })
      .then((response) => {
        let { status } = response.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          Dialog.success("操作成功", () => setPswEditShow(false));
        }
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  return (
    <div className="account-phonelogin account-login">
      <div className="phonelogin-body body">
        <div className="input">
          <div className="input-content">
            <div className="input-content-left">
              <span className="input-content-left-prefix">手机号</span>

              <input
                type="text"
                value={data.mobile}
                placeholder="请输入手机号"
                autoComplete="off"
                onChange={(e) => setData({ ...data, mobile: e.target.value })}
              />
            </div>

            {data.mobile ? (
              <CloseCircleOutlined
                className="clear"
                style={{ marginRight: 0 }}
                onClick={() => setData({ ...data, mobile: "" })}
              />
            ) : null}
          </div>
        </div>

        <div className="input code">
          <div className="input-content">
            <div className="input-content-left">
              <span className="input-content-left-prefix">验证码</span>

              <input
                type="tel"
                value={data.code}
                placeholder="请输入验证码"
                autoComplete="off"
                onChange={(e) => setData({ ...data, code: e.target.value })}
              />

              {data.code ? (
                <CloseCircleOutlined
                  className="clear"
                  onClick={() => setData({ ...data, code: "" })}
                />
              ) : null}
            </div>

            <div
              className={"code-btn " + (coding || codeTime ? "disable" : "")}
              onClick={code}
            >
              {coding ? (
                "发送中"
              ) : codeTime ? (
                <>
                  <p className="code-time">{codeTime}</p>秒后重试
                </>
              ) : (
                "获取验证码"
              )}
            </div>
          </div>
        </div>

        <div className="input code">
          <div className="input-content">
            <div className="input-content-left">
              <span className="input-content-left-prefix">新密码</span>

              <input
                name="newpassword"
                type={newpassword ? "password" : "text"}
                value={data.newpassword}
                placeholder="请设置登录密码"
                onChange={(e) =>
                  setData({ ...data, newpassword: e.target.value })
                }
              />

              {data.newpassword ? (
                <CloseCircleOutlined
                  className="clear"
                  onClick={() =>
                    setData((data) => ({ ...data, newpassword: "" }))
                  }
                />
              ) : null}
            </div>

            <div className="psw-eye" onClick={() => toggleNewpassword()}>
              {newpassword ? (
                <img src="/resources/account/show.png" />
              ) : (
                <img src="/resources/account/hidden.png" />
              )}
            </div>
          </div>
        </div>

        <div
          className={"btn " + (submitting ? "disable" : "")}
          style={{ marginTop: "48px" }}
          onClick={submit}
        >
          确认找回
        </div>
      </div>
    </div>
  );
};
